import { useEffect, useRef, useState } from "react";
import Api from "../../Api";
import { DateTime } from "luxon";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../header/Header";
import MyWeekControlBar from "./MyWeekControlBar";
import { useProfileStore } from "../../stores/profileStore";
import { shallow } from "zustand/shallow";
import { useAccountStore } from "../../stores/accountStore";
import { Week } from "../actuals/time_logging/by_default/week/Week";
import LoadingComponent from "../default_components/LoadingComponent";
import PropTypes from "prop-types";

const MyWeek = ({ match }) => {
  const navigate = useNavigate();
  const { myWeekDate } = useParams();

  const [bookings, setBookings] = useState(null);
  const [projects, setProjects] = useState(null);
  const [date, setDate] = useState(DateTime.now() || DateTime.fromISO(match.params.date));
  const [tasks, setTasks] = useState(null);
  const [managers, setManagers] = useState(null);
  const [currentUser] = useProfileStore((state) => [state.profile], shallow);
  const [account] = useAccountStore((state) => [state.account], shallow);

  const didYouKnowRef = useRef({});

  useEffect(() => {
    Api.Administrators.post_some_statistics("visited_my_week");

    if (myWeekDate === undefined) {
      navigate(`/my-week/${DateTime.now().toISODate()}`, {
        replace: true,
      });
    }

    const from = date.startOf("week");
    const to = from.plus({ days: 6 });

    getBookings(currentUser, from, to);
    getProjects().then((response) => {
      getManagers(response.data.map((project) => project.id));
    });
    Api.Tasks.get().then((res) => setTasks(res.data));
  }, []);

  const getBookings = (user, from, to) => {
    Api.Bookings.get([user.id], from, to).then((bookings_res) => {
      setBookings(bookings_res.data);
    });
  };

  const getProjects = () => {
    return Api.Projects.minimal().then((projects_res) => {
      setProjects(projects_res.data);
      return projects_res;
    });
  };

  const getManagers = (projectIds) => {
    Api.Projects.managers(projectIds).then(({ data }) => {
      setManagers(data);
    });
  };

  const changeDate = (newDate) => {
    const from = newDate;
    const to = newDate.plus({ days: 6 });

    getBookings(currentUser, from, to);
    getProjects().then((response) => {
      getManagers(response.data.map((project) => project.id));
    });

    setDate(newDate);
    navigate(`/my-week/${newDate.toISODate()}`, {
      replace: true,
    });
  };

  if (!bookings || !projects || !tasks || !managers) {
    return <LoadingComponent />;
  }

  return (
    <>
      <div className="my-week-page">
        <Header didYouKnowRef={didYouKnowRef} />
        {currentUser && account && <MyWeekControlBar date={date} changeDate={changeDate} />}

        <div className="actuals-grid">
          <Week
            startDate={date.startOf("week")}
            logs={bookings}
            projects={projects}
            createActivity={() => {}}
            createOccupation={() => {}}
            tasks={tasks}
            activities={[]}
            occupations={[]}
            updateActuals={() => {}}
            changeContextMenu={() => {}}
            copyLogRequest={() => {}}
            showWeekendLogs={true}
            changeTooltip={() => {}}
            copyEnabled={false}
            pastDateBlur={true}
            managers={managers}
            variant="my-week"
          />
        </div>
      </div>
    </>
  );
};

MyWeek.propTypes = {
  match: PropTypes.object,
};

MyWeek.displayName = "MyWeek";

export default MyWeek;
